import React, { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { ApiError } from '../../services/api';
import Button from '../common/Button';

export const AccountRecoveryForm: React.FC = () => {
  const { sendRecoveryLink, isLoading } = useAuth();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState<string>('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('idle');
    setMessage('');

    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setStatus('error');
      setMessage('Please enter a valid email address.');
      return;
    }

    try {
      await sendRecoveryLink(email);
      setStatus('success');
      setMessage('If the email is registered, a login link is on its way. Check your inbox — the link expires in 15 minutes.');
    } catch (err) {
      console.error('Failed to send recovery link', err);
      setStatus('error');
      setMessage(
        err instanceof ApiError && err.message
          ? err.message
          : 'Failed to send recovery link. Please try again.'
      );
    }
  };

  return (
    <form onSubmit={handleSubmit} style={{ width: '100%' }}>
      <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
        <input
          type="email"
          placeholder="you@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{
            flex: 1,
            padding: '10px',
            borderRadius: '4px',
            border: '1px solid #555',
            background: 'rgba(0,0,0,0.5)',
            color: 'white',
          }}
        />
        <Button type="submit" disabled={isLoading} variant="secondary">
          {isLoading ? 'Sending…' : 'Send Link'}
        </Button>
      </div>

      {status !== 'idle' && (
        <div style={{ marginTop: '8px', fontSize: '12px', color: status === 'success' ? '#4CAF50' : '#FF6B6B' }}>
          {message}
        </div>
      )}
    </form>
  );
};
